import state from './moduleCardholderState.js'
import mutations from './moduleCardholderMutations.js'
import actions from './moduleCardholderActions.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
}